import { Typography } from '@material-ui/core'

import StatusBox from '../../../screens/BookingList/StatusBox'
import { CheckStatusRoom } from '../../../types/checkStatus'
import useStyles from './styles/CheckStatusTableRow.styles'

interface CheckStatusTableRowProps {
  data: CheckStatusRoom
}

const CheckStatusTableRow: React.FC<CheckStatusTableRowProps> = ({ data }) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="body1">{data.displayCrsNumber}</Typography>
      </div>
      <div>
        <Typography variant="body1">{data.pmsNumber}</Typography>
      </div>
      <div>
        <Typography variant="body1">
          <StatusBox status={data.pmsStatus} />
        </Typography>
      </div>
    </div>
  )
}
export default CheckStatusTableRow
